export default "__VITE_ASSET__D$KV5i9j__"